import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-link-netsuite',
  templateUrl: './link-netsuite.component.html',
  styleUrls: ['./link-netsuite.component.scss'],
})
export class LinkNetsuiteComponent implements OnInit {
  @Input() partner;
  @Input() selectedPOS;
  @Input() modal;
  @Output() next = new EventEmitter();
  public busy = false;
  public connected = false;
  public syncing = false;
  public message = null;
  public broadcastChannel = new BroadcastChannel('NETSUITE_CHANNEL');
  public win;

  public configurationSaved: boolean = false;
  public companyID: string = '';
  public clientID: string = '';
  public clientSecret: string = '';

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private posIntegrationService: PosIntegrationService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.busy = false;
  }

  SaveSettings() {
    this.posIntegrationService
      .savePOSConnection(this.partner.PartnerID, {
        PartnerID: this.partner.PartnerID,
        CompanyID: this.companyID,
        ClientID: this.clientID,
        ClientSecret: this.clientSecret,
        POSID: 16,
      })
      .subscribe((x) => {
        this.posIntegrationService
          .getOAuthUrl(this.partner.PartnerID, 16)
          .subscribe((url) => {
            this.connectPOS(url);
          });
      });
  }

  connectPOS(url) {
    localStorage.setItem('POSPartnerID', this.partner.PartnerID); //Not Ideal but cant find another easy way to pass this to the other window, and the backend makes it more challenging

    this.busy = true;
    this.connected = false;
    this.message = null;

    this.win = this.launchOAuthPopup(url);
    this.checkWindow();
  }

  launchOAuthPopup(url) {
    var w = window.open(
      url,
      'POSForm',
      'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0,width=860,height=720',
    );
    return w;
  }

  checkWindow() {
    setTimeout(() => {
      if (this.win.parent === null) {
        this.posIntegrationService
          .checkPOSIntegration(this.partner.PartnerID, 16)
          .subscribe((x) => {
            this.busy = false;
            console.log(this.modal);
            if (this.modal !== undefined) this.modal.dismiss('Cross click');
            else this.next.emit();
          });
      } else {
        this.checkWindow();
      }
    }, 2000);
  }

  done() {
    this.next.emit();
  }

  skipToHubtiger() {
    this.router.navigateByUrl('/store/calendar');
  }
}
